import { render, staticRenderFns } from "./KnowledgeBaseSearch.vue?vue&type=template&id=0b12d3ba&lang=pug"
import script from "./KnowledgeBaseSearch.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports